export default {
  unnamed: '(sin nombre)',
  sumShort: 'suma por período',
  meanShort: 'promedio por período',
  total: 'Total',
  average: 'Promedio',
  noData: 'Sin datos en esta selección',
  noDataPeriod: 'Sin datos'
}
